import Badge from 'components/common/Badge';
import Icon from 'components/common/Icon';
import ChangeOrganization from 'components/dashboard/ChangeOrganization';
import NotFoundPage from 'components/errors/NotFoundPage';
import { useCurrentOrganization } from 'hooks/backend/organizations';
import { useHasRole } from 'hooks/users';
import { Navigate } from 'react-router-dom';
import DefaultLayout from '../layout/DefaultLayout';
import AdminPageNavigation from './AdminPageNavigation';
import OrganizationEventLogTable from './OrganizationEventLogTable';

export const SurveyLogs = () => {
  const isAdmin = useHasRole('admin');
  const currentOrganization = useCurrentOrganization();

  if (!isAdmin) {
    return <Navigate replace to={'/'} />;
  }

  if (!currentOrganization?.id) {
    return <NotFoundPage />;
  }

  return (
    <DefaultLayout>
      <div className="min-h-full pt-6 pb-32 px-8 bg-gray-50">
        <div className="flex items-start justify-between mb-10">
          <div className="space-y-1">
            <div className="text-xl text-primary-d-600 font-medium">
              Admin Portal
            </div>
            <ChangeOrganization />
          </div>
        </div>
        <div>
          {currentOrganization.useInvoice && (
            <div className="mb-4">
              <Badge
                color="primary"
                icon={<Icon id="check" />}
                iconPlacement="leading"
                size="md"
              >
                Invoice Approved
              </Badge>
            </div>
          )}
          <AdminPageNavigation currentPage="survey-logs" />
          <OrganizationEventLogTable organizationId={currentOrganization.id} />
        </div>
      </div>
    </DefaultLayout>
  );
};
